import { Country } from 'country-state-city';

export default function useCountryList() {
  return Country.getAllCountries();
}
